export async function optimizeImage(file, quality = 0.5) {
  return new Promise((resolve, reject) => {
    if (!file || !file.type.startsWith('image/')) {
      reject(new Error('Only image files are allowed'));
      return;
    }

    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    img.onload = () => {
      URL.revokeObjectURL(img.src);
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('Failed to optimize image'));
            return;
          }

          const originalSize = file.size;
          const optimizedSize = blob.size;
          const reduction = ((originalSize - optimizedSize) / originalSize) * 100;

          console.log('Image optimization:', {
            originalSize: `${(originalSize / 1024).toFixed(2)} KB`,
            optimizedSize: `${(optimizedSize / 1024).toFixed(2)} KB`,
            reduction: `${reduction.toFixed(2)}%`,
            format: 'WebP',
            quality: quality,
          });

          const optimizedFile = new File([blob], file.name.replace(/\.[^/.]+$/, '.webp'), {
            type: 'image/webp',
            lastModified: Date.now(),
          });

          resolve(optimizedFile);
        },
        'image/webp',
        quality
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(img.src);
      reject(new Error('Failed to load image'));
    };

    img.src = URL.createObjectURL(file);
  });
}
